export enum ChangeSetCategoryEnum {
    Unknown = 0,
    Product = 1,
    Procedure = 2,
    Coating = 3,
    CoatingNote = 4,
    CoatingManufacturer = 5,
    DraegerTube = 6,
    UscgGroupToProduct = 7,
    InterProductCompatibility = 8,
    StowageRule = 9,
    SafetyHazard = 10,
    CategoryDocument = 11,
}

export const getChangeSetCategoryName = (category: ChangeSetCategoryEnum): string => {
    switch (category) {
        case ChangeSetCategoryEnum.Product:
            return 'Product';
        case ChangeSetCategoryEnum.Procedure:
            return 'Procedure';
        case ChangeSetCategoryEnum.Coating:
            return 'Coating';
        case ChangeSetCategoryEnum.CoatingNote:
            return 'Coating Note';
        case ChangeSetCategoryEnum.CoatingManufacturer:
            return 'Coating Manufacturer';
        case ChangeSetCategoryEnum.DraegerTube:
            return 'Draeger Tube';
        case ChangeSetCategoryEnum.UscgGroupToProduct:
            return 'USCG Group';
        case ChangeSetCategoryEnum.InterProductCompatibility:
            return 'Product Compatibility';
        case ChangeSetCategoryEnum.StowageRule:
            return 'Stowage Rule';
        case ChangeSetCategoryEnum.SafetyHazard:
            return 'Safety Hazard';
        case ChangeSetCategoryEnum.CategoryDocument:
            return 'Category Document';
        case ChangeSetCategoryEnum.Unknown:
        default:
            return 'Unknown';
    }
};
